import endpoints from "@config/endpoints";
import { benef_api_error_message } from "@constants/beneficiaryConstant";
import { getData, postDataJSON } from "@services/CommonApiService";
import { errorLogger } from "@utils/applicationLogUtils";
import { encodeWithKeyAndShift } from "@utils/base64Utils";
import { toast } from "react-toastify";
import config from './../../config/config';

export const getLatestServiceAvailedDateByBenefId = async (beneficiaryId: any, isAbortion: any = false, serviceName?: any) => {
    try {
        if(beneficiaryId) {
            const url = serviceName 
                ? `${endpoints.getLatestServiceAvailedDateByBenefId}/${isAbortion}/${beneficiaryId}/${serviceName}`
                : `${endpoints.getLatestServiceAvailedDateByBenefId}/${isAbortion}/${beneficiaryId}`;
            const res = await getData<any>(url);
            return (res?.data || res?.data.length > 0) ? res : null;
        }
        return null;
    } catch (error: any) {
        toast.error(benef_api_error_message.GET_API_ERROR_MESSAGE(benef_api_error_message.LATEST_SERVICE_AVAILED_DATE_BY_BENEF_ID), {
            position: "top-center"
        });
        errorLogger(error?.response?.data || error?.response || error);
    };
};

export const sendSMSNotification = async (smsPayload: any) => {
    try {
        if(config.sendSMSTemp?.toLowerCase() === 'on') {
            const encodedPayload = encodeWithKeyAndShift(JSON.stringify(smsPayload));
            const smsResponse = await postDataJSON<any>(`${endpoints.smsNotifications}`, {data: encodedPayload});
            return smsResponse;
        } else {
            return;
        }
    } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error);
    }
};
